import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function usePayloadTask(optionalId) {
    const { payload, target } = useBoundContext()
    optionalId ??= target.id
    return payload ? ((payload.tasks ??= {})[optionalId] ??= {}) : {}
}
